<style scoped>
table.v-table tbody tr,
.theme--light.v-table tbody tr:not(:last-child) {
  cursor: pointer;
  border-bottom: 0;
}
table.v-table tbody td:last-child {
  padding: 0;
  width: 70px;
}
.more-hover-btn {
  display: none;
  width: 35px;
  height: 35px;
}
.theme--light.v-table tbody tr:hover .more-hover-btn {
  display: inline-flex;
}

tbody tr:first-of-type {
  background-color: #f6f6f6;
}
tr:nth-child(odd) {
  background: #f6f6f6;
}
.material-icons {
  display: inherit;
}
</style>

<template>
  <v-card>
    <v-layout row wrap>
      <v-flex xs6 pa-4>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs2 pa-4>
        <filter-days-select v-model="filterDays"></filter-days-select>
      </v-flex>
      <v-flex xs4 pa-4>
        <filter-status-select
          :selectedValues="filterStatus"
          @filterChange="onFilterStatusSelectChange"
        ></filter-status-select>
      </v-flex>
      <v-flex xs12>
        <v-alert
          v-if="alert"
          :value="!isLoading"
          :type="alert.type"
          v-html="alert.message"
        ></v-alert>
        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="getOrderList"
          :search="search"
          item-key="orderNo"
          class="elevation-1"
          disable-initial-sort
          hide-actions
        >
          <template v-slot:items="{ item }">
            <tr @click="openDetail(item.orderNo)" class="elevation-0">
              <td>{{ item.orderNo }}</td>
              <td><date-output :dateString="item.orderDate"></date-output></td>
              <td>{{ item.customersOrderNo }}</td>
              <td>{{ item.orderTypeText || item.orderType }}</td>
              <td>
                <order-status-indicator
                  :delivery-status="item.deliveryStatus"
                  :rejection-status="item.rejectionStatus"
                ></order-status-indicator>
              </td>
              <td>
                <v-btn
                  small
                  light
                  icon
                  fab
                  color="white"
                  class="more-hover-btn"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <div v-if="isLoading" style="text-align: center;">Please wait</div>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" type="error">
              Your search for "{{ search }}" has no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import FilterDaysSelect from "@/components/FilterDaysSelect.vue";
import FilterStatusSelect from "@/components/FilterStatusSelect.vue";
import DateOutput from "@/components/DateOutput.vue";
import OrderStatusIndicator from "@/components/OrderStatusIndicator.vue";

export default {
  name: "OrderStatusList",
  components: {
    FilterDaysSelect,
    FilterStatusSelect,
    DateOutput,
    OrderStatusIndicator
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Order No.", value: "orderNo" },
        { text: "Order Date", value: "orderDate" },
        { text: "Your Order No.", value: "customersOrderNo" },
        { text: "Order Type", sortable: false },
        { text: "Delivery Status", sortable: false },
        { text: "", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters(["getOrderList"]),
    ...mapGetters("customer", {
      customerId: "getCustomerId"
    }),
    alert() {
      return this.$store.state.order_status.alert;
    },
    isLoading() {
      return this.$store.state.order_status.isLoadingList;
    },
    filterDays: {
      get() {
        return this.$store.state.order_status.filterDays.toString();
      },
      set(value) {
        this.$store.commit("setFilterDays", { filterDays: value });
        this.$store.dispatch("fetchOrderList");
      }
    },
    filterStatus: {
      get() {
        return this.$store.state.order_status.filterStatus;
      }
    }
  },
  watch: {
    customerId: function() {
      this.$store.dispatch("fetchOrderList");
    }
  },
  methods: {
    openDetail(orderNo) {
      this.$router.push({
        name: "order_status_detail",
        params: { orderNo }
      });
    },
    onFilterStatusSelectChange(value) {
      this.$store.commit("setFilterStatus", { filterStatus: value });
    }
  },
  created() {
    if (this.customerId) {
      this.$store.dispatch("fetchOrderList");
    }
  }
};
</script>
